import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { RuleLogicMap } from '../../../../common/common'
import { isNumericFieldType } from './applyFieldRuleOptions'

const commonLogicOptions = [
  {
    label: '包含',
    value: RuleLogicMap.include
  },
  {
    label: '不包含',
    value: RuleLogicMap.exclude
  },
  {
    label: '为空',
    value: RuleLogicMap.isEmpty
  },
  {
    label: '不为空',
    value: RuleLogicMap.isNotEmpty
  }
]

const numericFieldLogicOptions = [
  {
    label: '等于',
    value: RuleLogicMap.equal
  },
  {
    label: '大于',
    value: RuleLogicMap.greaterThan
  },
  {
    label: '小于',
    value: RuleLogicMap.lessThan
  }
]

function ApplyFieldRuleLogic ({ value, ruleItem, disabled, onChange }) {
  const [logicOptions, setLogicOptions] = useState(commonLogicOptions)

  useEffect(() => {
    if (isNumericFieldType(ruleItem?.fieldType)) {
      setLogicOptions([
        commonLogicOptions[0],
        commonLogicOptions[1],
        ...numericFieldLogicOptions,
        commonLogicOptions[2],
        commonLogicOptions[3]
      ])
    } else {
      setLogicOptions(commonLogicOptions)
    }
  }, [ruleItem])

  return (
    <Select
      disabled={ disabled }
      value={ value }
      options={ logicOptions }
      onChange={ onChange }
      style={ { width: 100 } }
    ></Select>
  )
}

export default ApplyFieldRuleLogic
